var map = {
	"./add.svg": 68400,
	"./alipay.svg": 3349,
	"./arrdown.svg": 47216,
	"./arrleft.svg": 21759,
	"./arrup.svg": 43395,
	"./article-create.svg": 27380,
	"./article-ranking.svg": 77246,
	"./article.svg": 54007,
	"./audit.svg": 71996,
	"./bankcard.svg": 51503,
	"./bankcard1.svg": 67052,
	"./base-data.svg": 71297,
	"./bell.svg": 82100,
	"./binding.svg": 87098,
	"./blocked.svg": 97421,
	"./brandshop.svg": 83066,
	"./cart-down.svg": 17878,
	"./change-theme.svg": 71171,
	"./chart.svg": 62637,
	"./client-skin.svg": 74240,
	"./close.svg": 11861,
	"./cloth.svg": 12637,
	"./cloth1.svg": 26038,
	"./colapse.svg": 68056,
	"./collapse.svg": 35726,
	"./copy.svg": 49616,
	"./dashboard.svg": 42189,
	"./data-upload.svg": 77335,
	"./delete.svg": 19402,
	"./diagnosis.svg": 27062,
	"./disabled.svg": 53539,
	"./disdroy.svg": 30615,
	"./down.svg": 3315,
	"./download.svg": 60783,
	"./download2.svg": 1951,
	"./edit.svg": 17415,
	"./empty.svg": 71838,
	"./error.svg": 95463,
	"./example.svg": 51543,
	"./exit-fullscreen.svg": 47711,
	"./expand.svg": 79495,
	"./expaned.svg": 54646,
	"./eye-open.svg": 66359,
	"./eye.svg": 15906,
	"./financial.svg": 42344,
	"./fullscreen.svg": 58228,
	"./getback.svg": 32836,
	"./gouxuan.svg": 16258,
	"./group.svg": 99744,
	"./guide.svg": 52789,
	"./hamburger-closed.svg": 77549,
	"./hamburger-opened.svg": 30018,
	"./histoires.svg": 11407,
	"./image.svg": 37322,
	"./info.svg": 77131,
	"./international.svg": 90237,
	"./introduce.svg": 40510,
	"./inventory.svg": 60521,
	"./language.svg": 74157,
	"./link.svg": 30903,
	"./loading.svg": 35993,
	"./medtruansfer.svg": 38785,
	"./myreg.svg": 29777,
	"./nested.svg": 26069,
	"./new.svg": 35183,
	"./next.svg": 47220,
	"./outlinepay.svg": 42927,
	"./outorder.svg": 65407,
	"./package.svg": 75349,
	"./password.svg": 19732,
	"./permission.svg": 89378,
	"./personnel-info.svg": 18562,
	"./personnel-manage.svg": 7231,
	"./personnel.svg": 87565,
	"./prev.svg": 80564,
	"./refresh.svg": 6424,
	"./require.svg": 83000,
	"./reward.svg": 90386,
	"./role.svg": 57391,
	"./save.svg": 60636,
	"./search.svg": 37519,
	"./setting.svg": 7709,
	"./setting1.svg": 10966,
	"./shared.svg": 98296,
	"./shift.svg": 21729,
	"./size.svg": 49016,
	"./size1.svg": 77641,
	"./success.svg": 95484,
	"./table.svg": 32961,
	"./tel.svg": 1850,
	"./tree.svg": 32571,
	"./up.svg": 5548,
	"./upload.svg": 19056,
	"./user.svg": 75602,
	"./video.svg": 5176,
	"./viewer.svg": 24737,
	"./warn.svg": 64639,
	"./wechat.svg": 52545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;